import request from '@/utils/request'

const auth = {
    /**
     * 根据用户openid获取custId
     * @param {Object} data 
     * @param {string} data.openid
     */
    getCustId(params) {
        return request({
            url: '?s=Customer.Web.GetCustId',
            method: 'GET',
            params: params
        })
    },

    /**
     * 更新个人信息
     * @param {*} data 
     */
    updateUserInfo(data) {
        return request({
            url: '?s=Customer.Web.UpdateUserInfo',
            method: 'POST',
            data: data
        })
    },

    /**
     * 获取userSig密钥
     * @param {Object} data 
     * @param {string} data.identifier
     */
    getTIMGenSIg(params) {
        return request({
            url: '?s=App.Sign.GenSig',
            method: 'GET',
            params: params
        })
    },

    /**
     * 获取满意度评价信息
     * @param {Object} data
     * @param {string} data.identifier
     */
    getSatisfactionConfig(params) {
        return request({
            url:  process.env.VUE_APP_BASE_API+'?s=Customer.UserSession.getSatisfaction',
            method: 'GET',
            params: params
        })
    },

    /**
     * 满意度评价
     * @param {Object} data
     * @param {string} data.identifier
     */
    saveSatisfactionGrade(params) {
        return request({
            url:  process.env.VUE_APP_BASE_API+'?s=Customer.UserSession.saveSatisfaction',
            method: 'POST',
            data: params
        })
    },
}

export default auth